import { Outlet } from 'react-router-dom'
import { ReactNode } from 'react'

export type UseUsersLayoutReturn = {
  children: ReactNode
}

export function useUsersLayout(): UseUsersLayoutReturn {
  return { children: <Outlet /> }
}
